import { UrlObject } from "url";
import * as _ from "lodash";

import { getLocale } from "./helper";

export const moiTruongHocTapPage = {
  routeUrl(): UrlObject {
    let pathname = "/learning-environment";
    return {
      pathname
    };
  },
  routeUrlAlias(): UrlObject {
    let pathname = "/learning-environment";
    let locale = getLocale();

    if (!_.isEmpty(locale)) {
      pathname = `/${locale}` + pathname;
    }

    return { pathname };
  }
};
